import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FavoriteBtn } from '../components/FavoriteBtn';
import useAxios from '../hook/useAxios';
import useRouter from '../hook/useRouter';
import { ICollectionItem, ICollectionSubItem } from '../interface/ICollection';
import { RootState, store } from '../store';
import { CollectionItemSubItem } from './CollectionItemSubItem';

export const CollectionItem = ({ it }: { it: ICollectionItem }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const { res, loading, error, fetchData } = useAxios<ICollectionSubItem[]>();
    const [isShowLowPrice, isShowLowPriceSet] = useState(false);
    const { params, getValue, changeParam } = useRouter(['serverid']);
    const [subItems, setSubItems] = useState<ICollectionSubItem[]>(it.items);
    const [priceBtnData, priceBtnDataSet] = useState({
        type: '',
        text: it.completed ? '완료' : '최저가 보기',
    });

    useEffect(() => {
        if (isShowLowPrice) {
            (async () => {
                const data = await fetchData({
                    method: 'get',
                    l10n: l10n,
                    config: store.getState().main.config,
                    param: { serverId: getValue('serverid') },
                    path: `/${store.getState().main.config.service}/v2.0/dict/search/collection/${it.collectionId}/price`,
                });

                if (data) {
                    setSubItems((prev) => {
                        const newArra = prev.map((item) => {
                            const matchingItem = data.find((b) => b.itemId === item.itemId && b.enchantLevel === item.enchantLevel);
                            if (matchingItem) {
                                return {
                                    ...item,
                                    unitPrice: matchingItem.unitPrice,
                                    world: matchingItem.world,
                                };
                            }
                            return item;
                        });

                        const plus = newArra.some((item) => typeof item.unitPrice !== 'number' && !item.checked) ? '+' : '';
                        const tradable = newArra.some((item) => item.tradable === true);
                        const total = newArra.reduce((total, item) => {
                            if (item.checked) return total + 0;
                            return total + (item.unitPrice || 0);
                        }, 0);

                        if (tradable) {
                            if (total == 0) {
                                priceBtnDataSet({
                                    type: 'none',
                                    text: '매물 없음',
                                });
                            } else {
                                priceBtnDataSet({
                                    type: 'tradeable',
                                    text: `${replaceNum(total)} ${plus}`,
                                });
                            }
                        } else {
                            priceBtnDataSet({
                                type: 'tradedisable',
                                text: '거래 불가',
                            });
                        }

                        return newArra;
                    });
                }
            })();
        } else {
            priceBtnDataSet({
                type: '',
                text: it.completed ? '완료' : '최저가 보기',
            });
        }
    }, [isShowLowPrice]);

    return (
        <div className="tablerow">
            <div className="tablecell">
                <FavoriteBtn itemId={it.collectionId} isFav={it.favorite} type={'collection'} ga360str={'컬렉션_리스트_즐겨찾기_클릭'} />
            </div>
            <div className="tablecell">
                <span className="btn-item">
                    <strong className="name" data-itemgrade={it.grade}>
                        {it.collectionName}
                    </strong>
                </span>
                <span className="option">{it.options.join(', ')}</span>
            </div>
            <div className="tablecell">
                <button
                    className="btn-price"
                    disabled={it.completed}
                    data-areas="컬렉션_리스트_최저가보기_클릭"
                    data-pricetype={priceBtnData.type}
                    onClick={() => isShowLowPriceSet((current) => !current)}
                >
                    {priceBtnData.text}
                </button>
            </div>
            <div className="tablecell">
                <ul className={isShowLowPrice ? 'is-active' : ''}>
                    {subItems.map((sub: ICollectionSubItem, idx: number) => (
                        <CollectionItemSubItem
                            key={idx + '_' + it.collectionId + '_' + sub.itemId + '_' + sub.enchantLevel + '_' + sub.checked.toString()}
                            sub={sub}
                            isActive={isShowLowPrice}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};

export const replaceNum = (_num: number) => {
    let arr = _num
        .toString()
        .replace(/\B(?=(\d{4})+(?!\d))/g, ',')
        .split(',')
        .reverse();
    let arr2 = ['', '만 ', '억 '];
    let str = '';
    for (let i = 0; i < arr.length; i++) {
        let num = arr[i];
        num = num === '0000' ? '' : num + arr2[i];
        str = num + str;
    }
    return str;
};
